<template>
  <div>
    <div>
      <h2>Search and add a pin</h2>
      <import-image>
			</import-image>
      <GmapAutocomplete @place_changed='setPlace'/>
      <button @click='addMarker'> Add </button>
    </div>
    <br>
    <GmapMap :center='center' :zoom='12' style='width:100%;  height: 400px;' >
      <gmap-custom-marker :marker="{ lat: 52.47561, lng: 13.42891 }" @click="center=m.position" alignment="bottomright" >
        <img src="logo.png" />
        <div class="test"></div>
      </gmap-custom-marker>
    </GmapMap>
  </div>
</template>

<script>
import axios from 'axios';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import importImage from '../components/importImage.vue'

export default {
  name: 'GoogleMap',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      'import-image': importImage
  },
  data() {
    return {
      center: { lat: 52.47561, lng: 13.42891 },
      currentPlace: null,
      markers: [],
      places: [],
      image: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
    }
  },
  mounted() {
    axios
      .get('places.json')
      .then(response => (this.markers = response.data))
    this.geolocate();
  },
  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
        console.log(this.markers);
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
  },
};
</script>
